// Pure date helpers shared by the frontend and the Worker (no runtime deps).
// Event dates are fixed strings "YYYY-MM-DD"; parse as UTC to avoid TZ drift.

const TH_DAYS = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"];
const TH_DAYS_SHORT = ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];
const TH_MONTHS = [
  "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
  "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",
];
const EN_DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const EN_MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
const KO_DAYS = ["일", "월", "화", "수", "목", "금", "토"];

function parts(dateStr: string) {
  const d = new Date(`${dateStr}T00:00:00Z`);
  return {
    dow: d.getUTCDay(),
    day: d.getUTCDate(),
    month: d.getUTCMonth(),
    year: d.getUTCFullYear(),
  };
}

export function thaiDate(dateStr: string): string {
  const { dow, day, month, year } = parts(dateStr);
  return `วัน${TH_DAYS[dow]}ที่ ${day} ${TH_MONTHS[month]} ${year + 543}`;
}

export function enDate(dateStr: string): string {
  const { dow, day, month, year } = parts(dateStr);
  return `${EN_DAYS[dow]} ${day} ${EN_MONTHS[month]} ${year}`;
}

export function thaiDayName(dateStr: string): string {
  return TH_DAYS[parts(dateStr).dow];
}

export function enDayName(dateStr: string): string {
  return EN_DAYS[parts(dateStr).dow];
}

export function thaiDayShort(dateStr: string): string {
  return TH_DAYS_SHORT[parts(dateStr).dow];
}

export function koreanDate(dateStr: string): string {
  const { dow, day, month, year } = parts(dateStr);
  return `${year}년 ${month + 1}월 ${day}일 (${KO_DAYS[dow]})`;
}

export type DateLang = "th" | "en" | "ko";

export function localizedDate(dateStr: string, lang: DateLang): string {
  if (lang === "th") return thaiDate(dateStr);
  if (lang === "ko") return koreanDate(dateStr);
  return enDate(dateStr);
}
